<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-sacrifice-icon01.svg" alt="*" />あなたの潜在意識
				</span>
			</div><!-- end .type -->
			<div class="cover">
					他人本位{{sacrificeMindResult.percentageLeft}}%、自分本位{{sacrificeMindResult.percentageRight}}%
			</div><!-- end .cover -->	
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>心の余裕を常に推し量ることで、自分の力を発揮できるようになる</h2>
			<img src="../assets/result-detail-sacrifice-inleft01.svg" alt="*" class="visual" />
			<div class="caption">
				日頃から自分の余裕に注目すれば、あなたの内向性と潜在意識の特徴が相乗効果を発揮する。
			</div><!-- end .caption -->
			<p>今回の診断で、あなたの潜在意識は他人本位志向が強いことが分かりました。あなたは内向度が{{levelResult.percentage}}%とに高いため、この潜在意識と相まって、相手のことをとてもよく観察する優れた特性があると言えるでしょう。</p>
			<p>何が物事が生じるとき、あなたは「まず、他人はどうなのか？」ということに反射的かつ瞬発的な意識が芽生えます。要は、他人の内面、他人の内向的思考がどうかを深く考えてしまうのです。あなたの潜在意識は、他人を想うスピード感として長所になることがあれば、他人を気にしすぎて苦しむ短所になることもあります。</p>
			<p>あなたの内向度と潜在意識が良い掛け算となるのは、心に余裕を感じられる状況です。不慣れな場所やコントロール感のないアドリブは苦手な傾向があるでしょう。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>あなたは一度知りさえすれば、とても大きな心の余裕を掴むことができる</h2>
			<img src="../assets/result-detail-sacrifice-inleft02.svg" alt="*" class="visual" />
			<div class="caption">
				余裕の広さと大きさは、知識と体験を重ねた「既知」によって得られる
			</div><!-- end .caption -->
			<p>あなたの特性を引き上げる重要なキーワードは「既知」です。あなたは一度知りさえすれば、一度体験しさえすれば、次に同様のことをする際は、大きな余裕を積み上げることができます。</p>
			<p>内向度が高く、内面へ(脳内へ)意識が向くということは、一度の学習や経験で、周囲の人と比べて非常に深く多く吸収することができます。</p>
			<p>自身の偏ったパターンに埋没するよりかは、他人のペースに戦略的に巻き込れてみたり、新しい分野を掘り下げてみたりすることで、自然に既知レベルは上がり、あなたの心の余裕を形成することに繋がります。</p>
			<p>他人本位の潜在意識が高いあなたは、他人に傾聴する才能があり、それは高いカウンセリング能力へ発展します。一方、余裕を失うと、あなたの傾聴力は、「流されやすい」「他人任せ」といった行動を促してしまいます。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>まずは自分事で忙しくなり、自身のスキルや能力に繋がる「既知」に力を注ごう</h2>
			<img src="../assets/result-detail-sacrifice-inleft03.svg" alt="*" class="visual" />
			<div class="caption">
				他人本位だからこそ、他人に振り撒けるスキルや能力が増えれば、あなたの内向的個性はガツンと煌めく
			</div><!-- end .caption -->
			<p>一番の解決方法は、本当に好きなことを見つけ、没頭し、自分の軸を作るということ。あなたは好きなことに関しては、高い内向性で主体的かつ哲学的に行動を取ることができます。</p>
			<p>自分の好きな自分事で忙しくなってしまえば、、他人との無駄な接触機会が減り、本当に必要な関わりだけを獲得します。キーパーソンの意見に流されたり、素敵な人に任せたりすることが増えれば、流されやすい、他人任せといった個性はもはや強みにしかなりません。
			</p>
			<p>
				自分事に集中する中で、絞った選択肢の中で他人に巻き込まれてみてください。すると、自分よがりになり過ぎず、他人との関わりから偶然の知的体験を得ることができ、心の余裕も無理なく増やしていけるようになります。
			</p>
			<p>
				自分軸を持っていると、他人との無駄との思える関わりが、本当にやりたいことのヒントやアイデアとして生かせることが多くなるのです。いっけん苦手なことをしている機会が、本気なこと、得意なことの才能を伸ばすことに繋がるとなれば、あなたも楽しく飛び込めるようになるでしょう。
			</p>
			<p>
				このように、あなたの内向性は、自身の潜在意識の癖を上手に利用するだけで、人生を大きく上昇させることができるのです。
			</p>
		</div><!-- end .sentence -->
	</div><!-- end .contents -->			
</template>

<script>


export default {
	name: 'ResultDetailSacrificeInLeft',
	components: {

	},
	
	data: function () {
		return {
		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
